<div
  class="mx-auto flex h-full min-h-0 w-full max-w-6xl flex-col gap-4 overflow-hidden rounded-lg border border-gray-300 bg-white"
>
  <lib-feature-header
    [title]="'Attendance Settings'"
    (closeClick)="goBack()"
    [isLoading]="store.loading()"
  />

  <!-- Tab Navigation -->
  <div class="shrink-0">
    <sb-tabs-navigation
      [tabs]="tabs"
      [activeTab]="activeTab()"
      (tabChanged)="onTabChange($event)"
    />
  </div>

  <!-- Settings Tab -->
  @if (activeTab() === 'settings') {
  <div class="min-h-0 flex-1 overflow-y-auto">
    <div class="space-y-6 p-6" [formGroup]="form">
      <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
        <div class="rounded-lg border border-gray-200 p-4 md:col-span-2">
          <label class="flex cursor-pointer items-start gap-3">
            <input
              type="checkbox"
              class="mt-1 h-4 w-4 rounded border-gray-300 text-orange-600 focus:ring-orange-500"
              [checked]="autoCloseEnabled()"
              (change)="onAutoCloseToggle($event)"
              [disabled]="store.loading() || !canSave()"
            />
            <div>
              <div class="text-sm font-medium text-gray-900">
                Automatically close open attendance
              </div>
              <p class="mt-1 text-sm text-gray-600">
                When enabled, open attendance sessions will be closed
                automatically at the configured time of day.
              </p>
            </div>
          </label>
        </div>

        <div class="rounded-lg border border-gray-200 p-4">
          <label
            for="auto_close_time"
            class="block text-sm text-gray-700 transition-colors duration-200"
          >
            Auto Close Time
          </label>

          <input
            id="auto_close_time"
            type="time"
            formControlName="auto_close_time"
            class="relative mt-1 block w-full appearance-none rounded-md border border-gray-300 bg-white px-3 py-2 text-gray-900 placeholder-gray-300 transition-all duration-200 ease-in-out focus:z-10 focus:border-orange-500 focus:outline-none focus:ring-orange-500 disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-500"
            [disabled]="store.loading() || !canSave() || !autoCloseEnabled()"
          />

          @if (autoCloseTimeError()) {
          <p
            class="mt-1 animate-slideInLeft text-xs text-red-600"
            style="animation-delay: 50ms"
          >
            {{ autoCloseTimeError() }}
          </p>
          } @else {
          <p class="mt-1 text-xs text-gray-400">
            {{
              autoCloseEnabled()
                ? 'Set the daily cut-off time in HH:MM format.'
                : 'Enable automatic closing to configure a cut-off time.'
            }}
          </p>
          }
        </div>

        <lib-attendance-settings-current-state
          [hasPersistedSettings]="store.hasPersistedSettings()"
          [version]="store.settings()?.version ?? 0"
          [updatedAt]="store.settings()?.updated_at"
        />
      </div>
    </div>

    @if (store.error()) {
    <div class="px-4 pb-4">
      <lib-error-alert [error]="store.error()" />
    </div>
    }

    <div class="px-4 pb-4">
      <div class="flex justify-end space-x-4">
        <shared-submit-button
          [buttonText]="'Save'"
          [disabled]="form.invalid || store.loading() || !canSave()"
          [isLoading]="store.loading()"
          (buttonClick)="onSave()"
        />

        <shared-submit-button
          [buttonText]="'Cancel'"
          [variant]="'secondary'"
          (buttonClick)="goBack()"
        />
      </div>
    </div>
  </div>
  }

  <!-- Auto-Close Logs Tab -->
  @if (activeTab() === 'auto-close-logs') {
  <div class="min-h-0 flex-1 overflow-hidden px-4 pb-4">
    <lib-attendance-auto-close-logs-tab
      [logs]="logStore.logs()"
      [isLoading]="logStore.isLoading()"
      (daysChanged)="logStore.loadLogs($event)"
    />
  </div>
  }
</div>
